<template>
  <dd-dashboard-header-page
      class="automation-overview-component"
      :uses-filter="true"
      header="Automations">
    <template #header-buttons>
      <dd-list-button
          @click="openAutomationResultConfirmModal"
          :count="pendingConfirmationCount"
      >
        Handmatige controles
        <template #icon>
          <CheckboxMultipleOutlineIcon/>
        </template>
      </dd-list-button>
      <dd-button
          @click="onCreateClick">
        <template #icon>
          <PlusIcon class="icon-size-lg"/>
        </template>
        aanmaken
      </dd-button>
    </template>
    <template #filter-drawer>
      <FilterComponent v-show="filterLoaded"/>
    </template>
    <template #content>
      <div class="flex-col gap-lg">
        <AllResultsConfirmModal
            :visible="showResultConfirmModal"
            @close="closeAutomationResultConfirmModal"
        />
        <div class="flex-col gap-y-md">

          <SortingComponent/>

          <div class="automation-grid">
            <Automationable
                v-if="!loadingActiveAutomationables && selectedSortingCategory === OverviewSortOptionEnum.ACTIVE"
                v-for="(automationable, idx) in activeAutomationables"
                :key="automationable.model_type+automationable.id"
                :automationable="automationable">
            </Automationable>
            <Automationable
                v-if="!loadingOnceAutomationables && selectedSortingCategory === OverviewSortOptionEnum.ONCE"
                v-for="(automationable, idx) in onceAutomationables"
                :key="automationable.model_type+automationable.id"
                :automationable="automationable">
            </Automationable>
            <Automationable
                v-if="!loadingInactiveAutomationables && selectedSortingCategory === OverviewSortOptionEnum.INACTIVE"
                v-for="(automationable, idx) in inactiveAutomationables"
                :key="automationable.model_type+automationable.id"
                :automationable="automationable">
            </Automationable>
            <template v-if="loadingInactiveAutomationables || loadingActiveAutomationables || loadingOnceAutomationables">
              <AutomationsSkeleton v-for="index in 12" :key="index" />
            </template>
          </div>
        </div>
      </div>
    </template>
  </dd-dashboard-header-page>
</template>

<script>
import store from '../store'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import automationInterfaceApi from '~/api/automation_interface'
import keyValueStoreApi from '~/api/key_value_store'
import automationShowStore from '../components/show/store'
import FilterComponent from '../components/filter/FilterComponent.vue'
import AutomationsSkeleton from '../components/AutomationsSkeleton.vue'
import SortingComponent from '../components/index/SortingComponent.vue'
import Automationable from '../components/index/Automationable.vue'
import AllResultsConfirmModal from '../components/index/modals/AllResultsConfirmModal.vue'
import UnskippedResultsConfirmModal from '../components/index/modals/UnskippedResultsConfirmModal.vue'
import {OverviewSortOptionEnum} from "~/pages/automation/enums";

export default {
  name: 'IndexScreen',
  components: {
    FilterComponent,
    SortingComponent,
    Automationable,
    AutomationsSkeleton,
    AllResultsConfirmModal,
    UnskippedResultsConfirmModal,
  },
  beforeCreate () {
    const STORE_KEY = '$_automation'
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store)
    }
    const AUTOMATION_SHOW_STORE_KEY = '$_automation_show'
    // eslint-disable-next-line no-underscore-dangle
    if (!(AUTOMATION_SHOW_STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(AUTOMATION_SHOW_STORE_KEY, automationShowStore)
    }
  },
  activated () {
    this.getFilter()
    this.fetchAutomationables(true)
    this.fetchPendingConfirmationCount()
    this.clearConfiguredAutomationInterface()
  },
  data () {
    return {
      loaded: false,
      showCreate: false,
      showUnskippedResultConfirmModal: false,
      openGlobalAutomationModal: false,
      unskippedAutomations: [],
    }
  },
  computed: {
    ...mapGetters(`$_automation`, {
      inactiveAutomationables: 'inactiveAutomationables',
      activeAutomationables: 'activeAutomationables',
      onceAutomationables: 'onceAutomationables',
      loading: 'loading',
      unconfiguredGlobalAutomations: 'unconfiguredGlobalAutomations',
      selectedSortingCategory: 'selectedSortingCategory',
      pendingConfirmationCount: 'pendingConfirmationCount',
    }),
    ...mapState('$_automation', {
      showResultConfirmModal: 'showResultConfirmModal',
      loadingInactiveAutomationables: 'loadingInactiveAutomationables',
      loadingActiveAutomationables: 'loadingActiveAutomationables',
      loadingOnceAutomationables: 'loadingOnceAutomationables',
      filterLoaded: 'filterLoaded',
    }),
    OverviewSortOptionEnum() {
      return OverviewSortOptionEnum;
    },
  },
  methods: {
    ...mapActions({
      getMe: 'getMe',
    }),
    ...mapActions('$_automation', {
      getFilter: 'getFilter',
      fetchAutomationables: 'fetchAutomationables',
      selectGlobalAutomationConfiguration: 'selectGlobalAutomationConfiguration',
      selectAutomation: 'selectAutomation',
      findOrCreateGlobalAutomationConfigurationByGlobalAutomation: 'findOrCreateGlobalAutomationConfigurationByGlobalAutomation',
    }),
    ...mapMutations('$_automation', {
      setShowResultConfirmModal: 'SET_SHOW_RESULT_CONFIRM_MODAL',
      setPendingConfirmationCount: 'SET_PENDING_CONFIRMATION_COUNT',
    }),
    ...mapActions('$_automation_show', {
      clearConfiguredAutomationInterface: 'clearConfiguredAutomationInterface',
    }),
    onFilterDrawerStateChange (state) {
      keyValueStoreApi.set('automation_index_filter_drawer', state).then(() => {})
    },
    fetchPendingConfirmationCount () {
      automationInterfaceApi.getPendingConfirmationCount().then((count) => {
        this.setPendingConfirmationCount(count)
      })
    },
    openAutomationResultConfirmModal () {
      this.setShowResultConfirmModal(true)
    },
    closeAutomationResultConfirmModal () {
      this.setShowResultConfirmModal(false)
    },
    onCreateClick () {
      this.navigator.navigatePath(
        this.route('vue.dashboard.automations.create')
      )
    },
  },
}
</script>

<style lang="scss">
@use 'sass:map';
@import "~@/_default.scss";

.slim-card{
  padding-top: $spacing-md !important;
  padding-bottom: $spacing-md !important;
}

.automation-overview-component {
  .automation-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(800px, 1fr));
    gap: $spacing-md;
    row-gap: $spacing-md;
  }
}

.automation-card {
  .automation-card-content {
    background-color: $main-content-bg-color;
    padding: $spacing-md;
    border-radius: $border-radius-base;

    p {
      margin: 0 !important;
      font-size: $font-size-base !important;
    }
  }
}
</style>
